/**
 * Formats an amount in cents as a USD currency string.
 * Omits decimals if the value is a whole dollar (e.g. 19900 → "$199", 9950 → "$99.50", 572400 → "$5,724").
 *
 * @param cents - The amount in cents to format.
 * @returns The formatted currency string.
 */
export function formatCentsToDollarsCompact(cents: number): string {
  const dollars = cents / 100
  const isWholeDollar = cents % 100 === 0

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: isWholeDollar ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(dollars)
}

/**
 * Formats an amount in cents as a USD currency string.
 * Always includes two decimal places (e.g. 19900 → "$199.00", 9950 → "$99.50", 572400 → "$5,724.00").
 *
 * @param cents - The amount in cents to format.
 * @returns The formatted currency string.
 */
export function formatCentsToDollars(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100)
}
